/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RenderRequest
 */
export interface RenderRequest {
    /**
     * 
     * @type {string}
     * @memberof RenderRequest
     */
    destination: string;
}

export function RenderRequestFromJSON(json: any): RenderRequest {
    return RenderRequestFromJSONTyped(json, false);
}

export function RenderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'destination': json['destination'],
    };
}

export function RenderRequestToJSON(value?: RenderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'destination': value.destination,
    };
}


